<template>
  <!-- 预览图片-->
  <viewer :images="pictureList" ref="viewer" rebuild :options="{ initialViewIndex: 0,navbar: false, title: () => item.fileTitle}" class="picture-view-box" v-if="pictureList.length > 0">
    <div class="pic-list" v-for="pic in pictureList" :key="pic.id">
      <img :src="pic.pic" alt="" class="item-pic">
      <!-- 图片标题 -->
      <h4 class="pic-label" v-if="isShowFt">
        <slot>{{ pic.fileName }}</slot>
      </h4>
    </div>
  </viewer>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'pdfView',
  props: {
    pictureList: {
      // fileList中的某一项
      type: Array,
      default: () => [],
    },

    // 是否底部扩展信息
    isShowFt: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {}
  },

  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
    }),

    images() {
      let imgs = []
      imgs = this.pictureList.map((item) => {
        return item.perfix + item.path
      })
      return imgs
    },
  },

  created() {
    // console.log("pictureList==", this.pictureList)
  },

  methods: {
    inited(viewer, index) {
      this[`$viewer${index}`] = viewer
    },

    show(e, index) {
      this[`$viewer${index}`].show()
    },
  },
}
</script>
<style lang="scss" scope>
.picture-view-box {
  margin-right: 10px;
  z-index: 9999;
  .pic-list {
    float: left;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .item-pic {
    width: 64px;
    height: 64px;
    object-fit: cover;
    border-radius: 4px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// PictureList.vue?d0221568